module.exports = __webpack_public_path__ + "img/微信图片_20251029163307_18_62.4c1e9bef.jpg";